import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { ExtractedRecordUnfilledField } from '@/modules/ai/models/ExtractedRecordUnfilledField';

export abstract class BaseExtractedRecordModel extends BaseEntityModel {
  matchSummary?: string;
  type?: string;
  unfilled: ExtractedRecordUnfilledField[];
  provenance?: Record<string, unknown>;
  sourceDocumentIds: number[];

  constructor(model: Partial<BaseExtractedRecordModel> = {}) {
    super(model);

    this.matchSummary = model.matchSummary;
    this.type = model.type;
    this.unfilled = ExtractedRecordUnfilledField.mapModels(model.unfilled);
    this.provenance = model.provenance;
    this.sourceDocumentIds = model.sourceDocumentIds ?? [];
  }

  // Each staging table stores its match as its own foreign key, so the subclass answers this.
  abstract get hasMatch(): boolean;

  get showAmountColumn(): boolean {
    return true;
  }

  get hasMissingInfo(): boolean {
    return this.unfilled.length > 0;
  }

  get unfilledFields(): string[] {
    return this.unfilled
      .map((unfilled: ExtractedRecordUnfilledField): string | undefined => unfilled.field)
      .filter((field: string | undefined): field is string => !!field);
  }
}
